import { render, staticRenderFns } from "./product_custom_modification.vue?vue&type=template&id=016754b1&scoped=true&"
import script from "./product_custom_modification.vue?vue&type=script&lang=js&"
export * from "./product_custom_modification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016754b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('016754b1')) {
      api.createRecord('016754b1', component.options)
    } else {
      api.reload('016754b1', component.options)
    }
    module.hot.accept("./product_custom_modification.vue?vue&type=template&id=016754b1&scoped=true&", function () {
      api.rerender('016754b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_custom_modification.vue"
export default component.exports